import {useEffect} from "react";

import {useLocation} from "react-router-dom";

import PropTypes from "prop-types";

import MDBox from "../../MDBox";

import {useMaterialUIController, setLayout} from "../../../Context/mui";
import Loading from "../FormLayout/Components/Loading";

function DashboardLayout({children}) {
    const [controller, dispatch] = useMaterialUIController();
    const {miniSidenav} = controller;
    const {pathname} = useLocation();
    const location = useLocation();
    useEffect(() => {
        setLayout(dispatch, "dashboard");
    }, [pathname]);
    if (!location) return null
    const image = require("../../../Asset/images/bgforms1.png")

    return (
        <MDBox
            className="no-print"
            sx={({breakpoints, transitions, functions: {pxToRem}}) => ({
                p: 3,
                position: "relative",
                //
                height: "100%",
                minHeight: "100vh",
                // display: "flex",
                // flexDirection: "column",
                //

                backgroundImage: ({
                                      functions: {linearGradient, rgba},
                                      palette: {gradients},
                                  }) =>
                    `url(${image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",  

             
                [breakpoints.up("xl")]: {
                    marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
                    transition: transitions.create(["margin-left", "margin-right"], {
                        easing: transitions.easing.easeInOut,
                        duration: transitions.duration.standard,
                    }),
                },
            })}
        >
            <Loading>

                {children}
            </Loading>

        </MDBox>
    );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default DashboardLayout;
